import { Component } from '@angular/core';
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
@Component({
  selector: 'app-handheld-setting-admin-page',
  templateUrl: 'handheld-setting-admin.page.html',
  styleUrls: [
    './handheld-setting-admin.page.scss',
  ]
})
export class HandheldSettingAdminPage {
  settingsFields:any[];
  systemSetting:any[];
  loading:boolean=true ;
    constructor(
        private systemSettingService: SystemSettingService,
            private toasterService: ToasterService,
      ) { 
  
    }
 ngOnInit() {
  this.loadData();
   
  }
  async loadData() {
    this.loading=false;
    await this.systemSettingService.getHandheldAdminDetail().then((response) => {
        this.systemSetting = response?.systemSetting || {};
      });
        this.loading=true;

    }
  toggleSelection(setting: any, event: any) {
    setting.data = event.detail.checked;
  }

  async submitForm() {
    this.loading=false;
      const settings = this.systemSetting.map(s => ({
        key: s.name,  
        value: s.data
      }));
      const settingDetail = {
        settings
      };
    if (!settings) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Please fill out at least one fields."
      );
      this.loading=true;
      return;
    }
     await  this.systemSettingService.updateHandheldSystemAdmin(settingDetail).then((response) => {
      if (response.success === true) {
        this.toasterService.presentToast(
          "primary",
          "The settings were updated.",
          "Success"
        );
      } else {
        this.toasterService.presentToast(
          "danger",
          `Error adding handheld setting. ${response}`,
          "Error"
        );
      }
    });
this.loading=true;

  }

}